var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25px",
    height: "20px",
    viewBox: "0 0 31.596 31.596",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.354,2.942H2.241v20.195h27.113V2.942z M26.311,20.092H5.285V5.986h21.025V20.092L26.311,20.092z M31.596,24.977v3.677 H0v-3.677h12.097v1.838h7.401v-1.838H31.596z M11.627,16.168l-3.171-3.17l3.115-3.114l1.175,1.175l-1.939,1.939l1.995,1.995 L11.627,16.168z M15.003,17.492l-1.525-0.657l3.565-8.275l1.525,0.657L15.003,17.492z M18.793,14.993l1.995-1.995l-1.938-1.939 l1.174-1.175l3.115,3.114l-3.17,3.17L18.793,14.993z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorks);
export default __webpack_public_path__ + "static/media/works.1fa3c1e373fd37f6f737ec38e4a25c9f.svg";
export { ForwardRef as ReactComponent };